// extracted by mini-css-extract-plugin
export default {"root":"D3JUTjnvfGa0jP20SBE8","container":"Sa3W5raH25Ua7IWKXfw3"};